export default [
    {
      title: 'menu.Sales',
      icon: 'BarChartIcon',
      tagVariant: 'light-danger',
      route:'sales'
    },
  ]
  